import { inject } from "@angular/core";
import { CanMatchFn, Router } from "@angular/router";
import { environment } from "../../environments/environment";
import { isPageEnabled } from "./page-availability";

export const pageEnabledGuard: CanMatchFn = (route) =>
  isPageEnabled(environment.pages, route.path ?? "") || inject(Router).createUrlTree(["/map"]);
